export default __webpack_public_path__ + "static/media/stopwatch.aeb674a2.svg";